import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";

import "@/assets/scss/_index.scss";
import "@/orders";
import "@/plugins";
import "material-icons/iconfont/material-icons.scss";

import { i18n, prepareI18n } from "./i18n";
import { useRouter } from "./router";
import { prepareServices } from "./services";
import { useStore } from "./store";

import { addAxiosInterceptors } from "@/plugins/axios";
import App from "./App.vue";
import "./registerServiceWorker";

const APP_VERSION = process.env.VUE_APP_VERSION as string;
console.info(`Version: ${APP_VERSION}`);

export const store = useStore();

const router = useRouter(store);
prepareServices(store);
prepareI18n(store);

// Axios
addAxiosInterceptors(router);

// Auth event handlers
const handleAuthenticationStatusChange = async (isLogged: boolean) => {
  console.log("handleAuthenticationStatusChange", isLogged);
  await store.dispatch("setSignedIn", isLogged);
  if (isLogged) {
    await store.dispatch("initialize");
  } else {
    localStorage.removeItem("filteredOrders");
  }
};

// Setup auth event listeners
Vue.$auth.getUser().then(async (user) => {
  await handleAuthenticationStatusChange(!!user);
});
Vue.$auth.events.addUserLoaded(async (user) => {
  await handleAuthenticationStatusChange(!!user);
});
Vue.$auth.events.removeUserLoaded(async () => {
  await handleAuthenticationStatusChange(false);
});

Vue.config.productionTip = false;

// Create Vue instance
new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
